import { ReactNode } from 'react';

interface SalesItemWrapperProps {
  children: ReactNode;
}

export const SalesItemWrapper = ({ children }: SalesItemWrapperProps) => (
  <div className='border-greyMuted/50 pb-1 first:border-t first:pt-1 [&:not(:last-child)]:border-b'>{children}</div>
);

export const SalesItemContainer = ({ children }: SalesItemWrapperProps) => (
  <div className='mx-3 mb-3 flex flex-col gap-1'>{children}</div>
);
